import PropTypes from 'prop-types'
import { Table, Icon } from 'antd'
import history from 'utils/history'

const AboutPakdeView = ({
  aboutPakdeList,
}) => {
  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: text => text || '-',
    },
    {
      title: 'Short Description',
      dataIndex: 'content',
      key: 'content',
      render: text => (
        <div className="ellipsis-wrapper line-clamp"><p className="mb-0">{text || '-'}</p></div>
      ),
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'action',
      width: 80,
      fixed: 'right',
      render: (text, record) => (
        <div className="d-flex justify-content-around">
          <Icon type="edit" onClick={() => history.push(`/web-management/about-pak-d/${record.id}/edit`)} />
        </div>
      ),
    },
  ]

  return (
    <Table
      rowKey="id"
      className="table-striped-rows"
      columns={columns}
      dataSource={aboutPakdeList.data}
      loading={aboutPakdeList.isFetching}
      pagination={{
        hideOnSinglePage: true,
      }}
    />
  )
}

AboutPakdeView.propTypes = {
  aboutPakdeList: PropTypes.any,
}

export default AboutPakdeView
